import { isImageAttachment } from '../common/chatUploads';

export const putWithProgress = ({ uploadUrl, file, mimeType, onProgress, onXhr }) => (
    new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        onXhr(xhr);

        xhr.open('PUT', uploadUrl, true);
        xhr.setRequestHeader('Content-Type', mimeType);

        xhr.upload.onprogress = (event) => {
            if (!event.lengthComputable) return;
            onProgress(Math.round((event.loaded / event.total) * 100));
        };

        xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300) resolve();
            else reject(new Error('No se pudo subir el archivo. Inténtalo de nuevo.'));
        };
        xhr.onerror = () => reject(new Error('Error de red al subir el archivo.'));
        xhr.onabort = () => reject(Object.assign(new Error('Subida cancelada'), { aborted: true }));

        xhr.send(file);
    })
);

export { isImageAttachment };
